<template>
    <div class="">
        <div class="text-right mt-n2" v-if="isEditing">
            <button class="btn btn-sm btn-link text-secondary" @click="isEditing = false">
                <span class="fe fe-x"></span>
            </button>
        </div>
        <div class="comment-wrapper" v-if="isEditing">
            <div class="comment mb-3" v-for="(note, index) in notes" :key="index">
                <div class="row no-gutters">
                    <div class="col-auto">
                        <avatar size="avatar-xs" :src="note.user.avatar.preview" type="circle"></avatar>
                    </div>
                    <div class="col px-2">
                        <div class="comment-body w-100">
                            <div class="row no-gutters">
                                <div class="col">
                                    <h5 class="comment-title">{{ note.user.firstName }}</h5>
                                </div>
                                <div>
                                    <time class="comment-time">{{ note.updatedAt | moment("calendar") }}</time>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col mb-3">
                                    <p class="comment-text text-secondary" v-html="noteBody(note)"></p>
                                </div>
                                <div class="col-auto mr-n3" v-if="note.tooth && note.tooth.length">
                                    <div class="comment-text text-secondary">
                                        {{ $t('Tooth #') }}: {{ note.tooth.join(', ') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex flex-column">
                        <button
                            class="btn btn-sm btn-white mb-2"
                            @click="[confirmRemoveId === note._id ? confirmRemoveId = null : confirmRemoveId = note._id]"
                        >
                            <i class="fe" :class="[ confirmRemoveId === note._id ? ' fe-x' : 'fe-trash']"></i>
                        </button>
                        <button
                            class="btn btn-danger btn-sm"
                            v-if="confirmRemoveId === note._id"
                            @click="deleteNote(note)"
                        >
                            <i class="fe fe-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="!notes.length" class="d-flex justify-content-center align-items-center h-100">
                <span>{{ $t('Nothing yet') }}</span>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col" :class="{ 'mr-3': isEditing }">
                <label class="sr-only">{{ $t('Leave a comment') }}</label>
                <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': error }"
                    :placeholder="$t('Leave a comment')"
                    v-model="text"
                    @keyup.enter="createNote"
                    :disabled="isNoteCreatePending"
                    @focus="isEditing = true"
                />
            </div>
            <div class="col-auto">
                <button
                    @click="createNote"
                    type="button"
                    class="btn px-3 btn-primary"
                    v-if="isEditing"
                >
                    <div v-if="isNoteCreatePending" class="px-2">
                        <div class="absolute-center">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <span class="fe fe-check"></span>
                    </div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
    props: ['customerId', 'tooth'],
    components: {
        Avatar,
    },
    computed: {
        ...mapGetters('notes', {
            findNotesInStore: 'find',
        }),
        ...mapState('notes', {
            isNoteCreatePending: 'isCreatePending'
        }),
        notes() {
            return this.findNotesInStore(this.params).data;
        }
    },
    data() {
        return {
            params: {
                query: {
                    customerId: this.customerId,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            text: null,
            error: null,
            confirmRemoveId: null,
            isEditing: false
        }
    },
    watch: {
        isEditing(newVal) {
            this.$emit('isNoteEditMode', newVal)
        }
    },
    created() {
        if (this.tooth > 0) {
            this.params.query.tooth = this.tooth;
        }
        this.find(this.params);
    },
    methods: {
        ...mapActions('notes', ['find', 'remove', 'create']),
        noteBody(item) {
            return this.$n2br(item.text)
        },
        deleteNote(item) {
            this.remove(item._id).then(item => {
                this.$toasted.global.success({
                    message: 'Note has been deleted'
                });
            });
        },
        createNote() {
            this.error = null;
            this.create({text: this.text, customerId: this.customerId, tooth: this.tooth}).then(data => {
                this.text = '';
            }).catch(error => {
                this.error = error.message;
            })
        },
        close() {
            this.$root.$emit("bv::hide::popover");
        }
    },
}
</script>

<style lang="scss">
.popover {
    max-width: 450px;
    width: 100%;
    @media (max-width: 767px) {
        width: 98%;
    }
}
</style>

<style lang="scss" scoped>
.note-area {
    resize: none;
    height: 2.5rem;
    transition: all .25s ease-in-out;
}

.note-area-focus {
    height: 5rem;
}

.comment-wrapper {
    width: 100%;
    height: 12rem;
    overflow-y: auto;
    overflow-x: hidden;
}

.absolute-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
